import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AccountModel} from "../../angular/models/account.model";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";

export class AccountDeliveryActiveCtrl implements IController {

  account: AccountModel;
  isDemand: boolean;

  private loadLimit: number;
  private deliveriesRef: any;
  private infiniteScroll: any;
  private selectedIds: any;
  private selectedAgent: any;
  private defaultGroup: any;
  private groupList: any;
  private filterConfig: any;
  private isSmallScreen: boolean;

  constructor(private $log, private $deliveries, private deliveriesConstants,
              private $infiniteScroll, private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private $mdMedia) {
  }

  $onInit() {

    this.loadLimit = 20;
    this.selectedIds = [];
    this.selectedAgent = null;
    this.deliveriesRef = this.$deliveries();

    this.defaultGroup = this.deliveriesConstants.group.Active;

    this.groupList = [
      this.deliveriesConstants.group.Unassigned,
      this.deliveriesConstants.group.Assigned,
      this.deliveriesConstants.group.Started,
      this.deliveriesConstants.group.Aborted
    ];

    this.filterConfig = {
      customTemplates: this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates(),
      range: this.dateRangeTimeFiltersService.today(),
      group: undefined,
      queryString: undefined
    };

    this.deliveriesRef.$query(this._qetQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.deliveriesRef, this.loadLimit);
  };

  $doCheck() {
    this.isSmallScreen = !this.$mdMedia('gt-md');
  };

  public submitQuery(queryString) {
    this.filterConfig.queryString = queryString;
    this._query();
  }


  rangeChanged(range) {
    if (!_.isUndefined(range) && !_.isEqual(range.name, this.filterConfig.range.name)) {
      this.filterConfig.range = range;
      this._query();
    }
  }

  onGroupChanged(group) {
    this.filterConfig.group = group;
    this._query();
  }

  selectedIdsChanged(selectedIds) {
    this.selectedIds = selectedIds;
  }

  onSelectAgent(agent) {
    this.selectedAgent = agent;
    this._query();
  }

  // ******************************
  //        Internal methods
  // ******************************

  private _query() {
    this.selectedIds = [];
    this.deliveriesRef.$query(this._qetQueryPayload()).then(() => {
      this.infiniteScroll.reload();
    }, (resp) => {
      this.$log.debug('Fail to $query', resp);
    });
  }

  private _qetQueryPayload() {
    return {
      agentAccountIds: this.isDemand ? undefined : [this.account.id],
      accountIds: this.isDemand ? [this.account.id] : undefined,
      agentIds: _.get(this.selectedAgent, 'id') ? [this.selectedAgent.id] : undefined,
      from: this.filterConfig.range.dateStart,
      to: this.filterConfig.range.dateEnd,
      group: this.filterConfig.group || this.defaultGroup,
      // status:         this.filterConfig.status,
      query: this.filterConfig.queryString,
      limit: this.loadLimit
    };
  }

}

angular
  .module('bringoz.admin.accounts')
  .component('accountDeliveryActive', {
    bindings: {
      account: '<',
      isDemand: '<'
    },
    template: require('./account-delivery-active.html').default,
    controller: AccountDeliveryActiveCtrl
  });
